import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faCheck } from '@fortawesome/free-solid-svg-icons';
import {
  updateArchiveServiceSetting as updateArchiveServiceSettingApi
} from "../../../../../api/clients/archiveServices";
import { Link } from "react-router-dom";
import { ARCHIVE_SERVICE_STATUSES } from "../../../../../config/constants";
import { NOTIFICATION_ARCHIVE_SERVICE_ACTIONS } from '../../../../../config/notifications';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function ReactivateArchiveService(props) {
  const [ showReactivateModal, setShowReactivateModal ] = useState( false );

  const { index, actionCallback, archiveServiceSetting, showIcon } = props;

  const reactivateArchiveService = () => {
    updateArchiveServiceSettingApi( {
      archiveServiceSettingId: archiveServiceSetting.id,
      data: {
        status: ARCHIVE_SERVICE_STATUSES.ENABLED,
      },
      notificationId: NOTIFICATION_ARCHIVE_SERVICE_ACTIONS
    } ).then( (response) => {
      setShowReactivateModal( false );

      if (response?.data?.id) {
        actionCallback();
      }
    } );
  };

  const shouldDisplay = (archiveServiceSetting) => {
    // Only show reactivate button when service is disabled by mysign admin
    return archiveServiceSetting?.id &&
           archiveServiceSetting?.status === ARCHIVE_SERVICE_STATUSES.DISABLED_BY_MYSIGN_ADMIN;
  }

  if (! shouldDisplay( archiveServiceSetting )) {
    return null;
  }

  return ( <Fragment>
      {! showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-success"
            type="button"
            id={`reactivate-archive-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowReactivateModal( true )
            }}
          >
            <FormattedMessage
              id="components.pages.organizations.table.actionButtons.reactivate_archive_service"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`reactivate-archive-icon-${index}`}
            modifiers={{
              preventOverflow: {
                enabled: true,
                boundariesElement: "body",
              },
            }}
          >
            <FormattedMessage
              id="components.pages.organizations.table.actionButtons.reactivate_archive_service"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`reactivate-archive-icon-` + props.index}
            onClick={() => setShowReactivateModal( true )}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faBox}
            />
            <FontAwesomeIcon
              size="lg"
              className="pt-1 cursor-pointer text-success"
              pointerEvents="none"
              icon={faCheck}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`reactivate-archive-icon-${props.index}`}
            modifiers={
              {
                preventOverflow: {
                  enabled: true,
                  boundariesElement: 'body'
                }
              }
            }
          >
            <FormattedMessage
              id="components.pages.organizations.table.actionButtons.reactivate_archive_service"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showReactivateModal}
        closeModal={() => setShowReactivateModal( false )}
        confirmationYes={reactivateArchiveService}
        messageId="components.layout.confirmation.body.reactivate_archive_service"
      />
    </Fragment>
  );
}

ReactivateArchiveService.defaultProps = {
  index: 0,
  archiveServiceSetting: null,
  showIcon: false,
  actionCallback: () => {},
};

export { ReactivateArchiveService };
